// source: status_entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.himpb.EDeviceType', null, global);
goog.exportSymbol('proto.himpb.ELineReason', null, global);
goog.exportSymbol('proto.himpb.ELineStatus', null, global);
goog.exportSymbol('proto.himpb.GetUserStatusReq', null, global);
goog.exportSymbol('proto.himpb.GetUserStatusRsp', null, global);
goog.exportSymbol('proto.himpb.TSyncUserInfo', null, global);
goog.exportSymbol('proto.himpb.TUserLoginInfo', null, global);
goog.exportSymbol('proto.himpb.TUserStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TUserStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TUserStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TUserStatus.displayName = 'proto.himpb.TUserStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TUserLoginInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TUserLoginInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TUserLoginInfo.displayName = 'proto.himpb.TUserLoginInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.GetUserStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.GetUserStatusReq.repeatedFields_, null);
};
goog.inherits(proto.himpb.GetUserStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.GetUserStatusReq.displayName = 'proto.himpb.GetUserStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.GetUserStatusRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.GetUserStatusRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.GetUserStatusRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.GetUserStatusRsp.displayName = 'proto.himpb.GetUserStatusRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TSyncUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TSyncUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TSyncUserInfo.displayName = 'proto.himpb.TSyncUserInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TUserStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TUserStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TUserStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TUserStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    devicetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    roomid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 6, 0),
    gateid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TUserStatus}
 */
proto.himpb.TUserStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TUserStatus;
  return proto.himpb.TUserStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TUserStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TUserStatus}
 */
proto.himpb.TUserStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.EDeviceType} */ (reader.readEnum());
      msg.setDevicetype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.ELineStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.ELineReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGateid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TUserStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TUserStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TUserStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TUserStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getGateid();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getSessionid();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.himpb.TUserStatus.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional EDeviceType deviceType = 2;
 * @return {!proto.himpb.EDeviceType}
 */
proto.himpb.TUserStatus.prototype.getDevicetype = function() {
  return /** @type {!proto.himpb.EDeviceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.EDeviceType} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string roomId = 3;
 * @return {string}
 */
proto.himpb.TUserStatus.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 timestamp = 4;
 * @return {number}
 */
proto.himpb.TUserStatus.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional ELineStatus status = 5;
 * @return {!proto.himpb.ELineStatus}
 */
proto.himpb.TUserStatus.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ELineStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.ELineStatus} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional ELineReason reason = 6;
 * @return {!proto.himpb.ELineReason}
 */
proto.himpb.TUserStatus.prototype.getReason = function() {
  return /** @type {!proto.himpb.ELineReason} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.ELineReason} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional uint32 gateId = 7;
 * @return {number}
 */
proto.himpb.TUserStatus.prototype.getGateid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setGateid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 sessionId = 8;
 * @return {number}
 */
proto.himpb.TUserStatus.prototype.getSessionid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TUserStatus} returns this
 */
proto.himpb.TUserStatus.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TUserLoginInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TUserLoginInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TUserLoginInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TUserLoginInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    devicetype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    devudid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientversion: jspb.Message.getFieldWithDefault(msg, 3, 0),
    versioninfo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    clientip: jspb.Message.getFieldWithDefault(msg, 5, 0),
    clientinfo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    appkey: jspb.Message.getFieldWithDefault(msg, 7, ""),
    appsecret: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TUserLoginInfo}
 */
proto.himpb.TUserLoginInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TUserLoginInfo;
  return proto.himpb.TUserLoginInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TUserLoginInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TUserLoginInfo}
 */
proto.himpb.TUserLoginInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EDeviceType} */ (reader.readEnum());
      msg.setDevicetype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDevudid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClientversion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersioninfo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClientip(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientinfo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppsecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TUserLoginInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TUserLoginInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TUserLoginInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TUserLoginInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicetype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDevudid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientversion();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getVersioninfo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClientip();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getClientinfo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAppsecret();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional EDeviceType deviceType = 1;
 * @return {!proto.himpb.EDeviceType}
 */
proto.himpb.TUserLoginInfo.prototype.getDevicetype = function() {
  return /** @type {!proto.himpb.EDeviceType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EDeviceType} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string devUDID = 2;
 * @return {string}
 */
proto.himpb.TUserLoginInfo.prototype.getDevudid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setDevudid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 clientVersion = 3;
 * @return {number}
 */
proto.himpb.TUserLoginInfo.prototype.getClientversion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setClientversion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string versionInfo = 4;
 * @return {string}
 */
proto.himpb.TUserLoginInfo.prototype.getVersioninfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setVersioninfo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 clientIp = 5;
 * @return {number}
 */
proto.himpb.TUserLoginInfo.prototype.getClientip = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setClientip = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string clientInfo = 6;
 * @return {string}
 */
proto.himpb.TUserLoginInfo.prototype.getClientinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setClientinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string appKey = 7;
 * @return {string}
 */
proto.himpb.TUserLoginInfo.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string appSecret = 8;
 * @return {string}
 */
proto.himpb.TUserLoginInfo.prototype.getAppsecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TUserLoginInfo} returns this
 */
proto.himpb.TUserLoginInfo.prototype.setAppsecret = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.GetUserStatusReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.GetUserStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.GetUserStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.GetUserStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.GetUserStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    peeridsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.GetUserStatusReq}
 */
proto.himpb.GetUserStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.GetUserStatusReq;
  return proto.himpb.GetUserStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.GetUserStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.GetUserStatusReq}
 */
proto.himpb.GetUserStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPeerids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.GetUserStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.GetUserStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.GetUserStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.GetUserStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeeridsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string peerIds = 1;
 * @return {!Array<string>}
 */
proto.himpb.GetUserStatusReq.prototype.getPeeridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.GetUserStatusReq} returns this
 */
proto.himpb.GetUserStatusReq.prototype.setPeeridsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.GetUserStatusReq} returns this
 */
proto.himpb.GetUserStatusReq.prototype.addPeerids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.GetUserStatusReq} returns this
 */
proto.himpb.GetUserStatusReq.prototype.clearPeeridsList = function() {
  return this.setPeeridsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.GetUserStatusRsp.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.GetUserStatusRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.GetUserStatusRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.GetUserStatusRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.GetUserStatusRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    statuslistList: jspb.Message.toObjectList(msg.getStatuslistList(),
    proto.himpb.TUserStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.GetUserStatusRsp}
 */
proto.himpb.GetUserStatusRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.GetUserStatusRsp;
  return proto.himpb.GetUserStatusRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.GetUserStatusRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.GetUserStatusRsp}
 */
proto.himpb.GetUserStatusRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.himpb.TUserStatus;
      reader.readMessage(value,proto.himpb.TUserStatus.deserializeBinaryFromReader);
      msg.addStatuslist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.GetUserStatusRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.GetUserStatusRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.GetUserStatusRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.GetUserStatusRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatuslistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.himpb.TUserStatus.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TUserStatus statusList = 1;
 * @return {!Array<!proto.himpb.TUserStatus>}
 */
proto.himpb.GetUserStatusRsp.prototype.getStatuslistList = function() {
  return /** @type{!Array<!proto.himpb.TUserStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TUserStatus, 1));
};


/**
 * @param {!Array<!proto.himpb.TUserStatus>} value
 * @return {!proto.himpb.GetUserStatusRsp} returns this
*/
proto.himpb.GetUserStatusRsp.prototype.setStatuslistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.himpb.TUserStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TUserStatus}
 */
proto.himpb.GetUserStatusRsp.prototype.addStatuslist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.himpb.TUserStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.GetUserStatusRsp} returns this
 */
proto.himpb.GetUserStatusRsp.prototype.clearStatuslistList = function() {
  return this.setStatuslistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TSyncUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TSyncUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TSyncUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSyncUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    usertype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    appid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    apptype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    devicetype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    clientversion: jspb.Message.getFieldWithDefault(msg, 6, 0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 9, 0),
    nickname: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TSyncUserInfo}
 */
proto.himpb.TSyncUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TSyncUserInfo;
  return proto.himpb.TSyncUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TSyncUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TSyncUserInfo}
 */
proto.himpb.TSyncUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsertype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setApptype(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.EDeviceType} */ (reader.readEnum());
      msg.setDevicetype(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClientversion(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 8:
      var value = /** @type {!proto.himpb.ELineStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {!proto.himpb.ELineReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TSyncUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TSyncUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TSyncUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSyncUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsertype();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApptype();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getClientversion();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.himpb.TSyncUserInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 userType = 2;
 * @return {number}
 */
proto.himpb.TSyncUserInfo.prototype.getUsertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setUsertype = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string appId = 3;
 * @return {string}
 */
proto.himpb.TSyncUserInfo.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 appType = 4;
 * @return {number}
 */
proto.himpb.TSyncUserInfo.prototype.getApptype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setApptype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional EDeviceType deviceType = 5;
 * @return {!proto.himpb.EDeviceType}
 */
proto.himpb.TSyncUserInfo.prototype.getDevicetype = function() {
  return /** @type {!proto.himpb.EDeviceType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.EDeviceType} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional uint32 clientVersion = 6;
 * @return {number}
 */
proto.himpb.TSyncUserInfo.prototype.getClientversion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setClientversion = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 timestamp = 7;
 * @return {number}
 */
proto.himpb.TSyncUserInfo.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional ELineStatus status = 8;
 * @return {!proto.himpb.ELineStatus}
 */
proto.himpb.TSyncUserInfo.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ELineStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.himpb.ELineStatus} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional ELineReason reason = 9;
 * @return {!proto.himpb.ELineReason}
 */
proto.himpb.TSyncUserInfo.prototype.getReason = function() {
  return /** @type {!proto.himpb.ELineReason} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.himpb.ELineReason} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string nickName = 10;
 * @return {string}
 */
proto.himpb.TSyncUserInfo.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSyncUserInfo} returns this
 */
proto.himpb.TSyncUserInfo.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * @enum {number}
 */
proto.himpb.EDeviceType = {
  NONE: 0,
  ANDROID: 1,
  GLASSES: 2,
  IOS: 3,
  WINDOWS: 4,
  WEB: 5,
  WEBADMIN: 6,
  H100: 7,
  CIMO: 8,
  WU_KONG: 9
};

/**
 * @enum {number}
 */
proto.himpb.ELineStatus = {
  OFFLINE: 0,
  ONLINE: 1,
  ERRLINE: 100
};

/**
 * @enum {number}
 */
proto.himpb.ELineReason = {
  OFFLINE_REASON_UNKONWN: 0,
  OFFLINE_REASON_LOSTCONNECT: 1,
  OFFLINE_REASON_CONNECTED: 2,
  OFFLIN_REASON_WAIT_RECONFIRM: 3,
  OFFLINE_REASON_EXIT: 4,
  OFFLIN_REASON_TIMEOUT: 5,
  OFFLIN_REASON_MULTI_DEVICE: 6,
  ONLINE_REASON_LOGIN: 10,
  ONLINE_REASON_KEEPLIVE: 11,
  ONLINE_REASON_TALKING: 12,
  ONLINE_LOCALSTATUS_MIN: 100,
  ONLINE_LOCALSTATUS_LIVEBROADCAST: 101,
  ONLINE_LOCALSTATUS_MAX: 120
};

goog.object.extend(exports, proto.himpb);
